import { render } from "./index.vue?vue&type=template&id=3e6d2118&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3e6d2118&lang=less"

import exportComponent from "D:\\test\\newDemo\\alp-ui\\vue-component\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__